// Sommaire d'article : liste les H2/H3 du contenu, crée des ancres stables (accents conservés en lettres simples).
(() => {
  const init = () => {
    document.querySelectorAll('[data-sv-toc]').forEach((toc) => {
      if (toc.dataset.pret) return;
      toc.dataset.pret = '1';
      const contenu = document.querySelector('.blog-post-content');
      const titres = contenu ? contenu.querySelectorAll('h2, h3') : [];
      if (!titres.length) return;

      const bouton = toc.querySelector('[data-sv-toc-bouton]');
      const panneau = toc.querySelector('[data-sv-toc-contenu]');
      const liste = toc.querySelector('[data-sv-toc-liste]');
      const deja = new Set();

      titres.forEach((t) => {
        if (!t.id) {
          let id = t.textContent
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .trim()
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .slice(0, 80) || 'section';
          let unique = id;
          let n = 2;
          while (deja.has(unique) || document.getElementById(unique)) unique = `${id}-${n++}`;
          t.id = unique;
        }
        deja.add(t.id);
        const li = document.createElement('li');
        li.className = t.tagName === 'H3' ? 'sv-toc__h3' : 'sv-toc__h2';
        const a = document.createElement('a');
        a.href = `#${t.id}`;
        a.textContent = t.textContent.trim();
        li.appendChild(a);
        liste.appendChild(li);
      });

      bouton.addEventListener('click', () => {
        const ouvert = bouton.getAttribute('aria-expanded') === 'true';
        bouton.setAttribute('aria-expanded', String(!ouvert));
        panneau.hidden = ouvert;
      });
      toc.hidden = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
